import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const IMG = "https://images.unsplash.com/photo-1531339413195-cc6c17163974?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHwxfHxpbmRpYW4lMjBzZW5pb3IlMjBjaXRpemVufGVufDB8fHx8MTc4OTYyNzI1M3ww&ixlib=rb-4.1.0&q=85";

export default function About() {
  return (
    <div className="p1-container py-14 lg:py-20" data-testid="about-page">
      <div className="grid items-center gap-10 lg:grid-cols-2">
        <div>
          <p className="p1-eyebrow">About ParentOne</p>
          <h1 className="mt-3 font-heading text-3xl font-bold leading-tight tracking-tight text-stone-900 sm:text-4xl lg:text-5xl">
            Founded on a phone call nobody wants to get.
          </h1>
          <div className="mt-5 space-y-4 text-lg leading-relaxed text-stone-600">
            <p>Every family living away from ageing parents knows that 3 AM fear. ParentOne Care Private Limited was founded in Jaipur to make sure distance never becomes neglect.</p>
            <p>We are a technology-enabled care-management company: real, background-verified people on the ground, coordinated by software that keeps families informed in five seconds — not buried in hospital jargon.</p>
            <p className="font-editorial text-xl italic text-emerald-950">Our mission: let adult children be their parents' child again — not their logistics coordinator.</p>
          </div>
          <Link to="/contact" className="p1-btn-primary mt-8" data-testid="about-contact-cta">Talk to us <ArrowRight className="h-4 w-4" /></Link>
        </div>
        <div className="overflow-hidden rounded-3xl border border-stone-200 shadow-lg">
          <img src={IMG} alt="Smiling Indian senior" className="h-[420px] w-full object-cover" data-testid="about-image" />
        </div>
      </div>
      <div className="mt-16 grid gap-5 sm:grid-cols-3">
        {[
          { v: "Jaipur", l: "Launch city — expanding soon" },
          { v: "18+", l: "Coordinated services, one team" },
          { v: "Always-on", l: "SOS escalation workflow" },
        ].map((s) => (
          <div key={s.l} className="p1-card p-6 text-center" data-testid={`about-stat-${s.l.slice(0, 8)}`}>
            <p className="font-heading text-3xl font-extrabold text-emerald-900">{s.v}</p>
            <p className="mt-1 text-sm text-stone-500">{s.l}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
